import "./Prices.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PricesOverview from "./sections/PricesOverview";
import Konferenzraum from "./sections/Konferenzraum";
import Preisgestaltung from "./sections/Preisgestaltung";
import PackageComparisonOverview from "./sections/PackageComparisonOverview";
import Footer from "@/reusable_sections/Footer";
export default function PricesPage() {
  return <div>
      <Header />
      <Hero />
      <PricesOverview />
      <Konferenzraum />
      <Preisgestaltung />
      <PackageComparisonOverview />
      <Footer />
    </div>;
}